// extracted by mini-css-extract-plugin
export default {"hsAreaChart":"Area_hsAreaChart__KAfih","arrowContLeft":"Area_arrowContLeft__iJioQ","arrowContRight":"Area_arrowContRight__HuraY","eChart":"Area_eChart__df7ny"};